




























































































































































import { Component, Ref, Vue } from "vue-property-decorator";
import api from "@/api/index";
import { AuthenticateModel, TenantDto } from "@/api/appService";
import { ElForm } from "element-ui/types/form";
import { validStrongPassword } from "@/utils/validate";

@Component({
  name: "Login",
})
export default class Login extends Vue {
  @Ref() readonly dataForm!: ElForm;

  form: AuthenticateModel = {
    userNameOrEmailAddress: "",
    password: "",
    rememberClient: true,
  };

  tenant: TenantDto = (this.$store.getters["app/tenant"] as TenantDto) || {};

  workWeiXinId = "";

  errorInfo = "";

  logging = false;

  mustChangePassword = false;

  passwordChangeToken = "";

  changeForm = {
    newPassword: "",
    confirmPassword: "",
  };

  created() {
    console.log("tenant", this.tenant);
    api.tenant.getForCurrent().then((res) => {
      this.$store.commit("app/SET_TENANT", res);
      this.$store.commit("tenant/SET_TENANT", res);
      this.tenant = res;
    });
  }

  loginByAccount() {
    (this.$refs.dataForm as any).validate((isValid: boolean) => {
      if (!isValid) {
        return;
      }

      this.logging = true;

      api.tokenAuth
        .authenticate({ body: this.form })
        .then((res) => {
          if (res.mustChangePassword) {
            this.mustChangePassword = true;
            this.passwordChangeToken = res.passwordChangeToken || "";
            this.logging = false;
            return;
          }
          (this as any).$store.dispatch("user/login", res).then(() => {
            this.$router.push("/");
          });
        })
        .catch((err) => {
          this.errorInfo = err;
          this.logging = false;
        });
    });
  }

  cancelChange() {
    this.mustChangePassword = false;
    this.passwordChangeToken = "";
    this.changeForm.newPassword = "";
    this.changeForm.confirmPassword = "";
    this.form.password = "";
    this.logging = false;
  }

  submitNewPassword() {
    (this.$refs.changeForm as any).validate((isValid: boolean) => {
      if (!isValid) {
        return;
      }
      this.logging = true;
      api.tokenAuth
        .changeWeakPassword({
          body: {
            userNameOrEmailAddress: this.form.userNameOrEmailAddress,
            currentPassword: this.form.password,
            newPassword: this.changeForm.newPassword,
            passwordChangeToken: this.passwordChangeToken,
          },
        })
        .then((res) => {
          if (!res.accessToken) {
            this.logging = false;
            return;
          }
          (this as any).$store.dispatch("user/login", res).then(() => {
            this.$router.push("/");
          });
        })
        .catch(() => {
          this.logging = false;
        });
    });
  }

  loginFormRules = {
    userNameOrEmailAddress: [
      {
        required: true,
        message: "请输入账号",
        trigger: "blur",
      },
    ],
    password: [
      {
        required: true,
        message: "请输入密码",
      },
    ],
  };

  changeFormRules = {
    newPassword: [
      {
        required: true,
        message: "请输入新密码",
        trigger: "blur",
      },
      {
        validator: validStrongPassword,
        trigger: "blur",
      },
    ],
    confirmPassword: [
      {
        required: true,
        message: "请再次输入新密码",
        trigger: "blur",
      },
      {
        validator: (_rule: any, value: string, callback: (error?: Error) => void) => {
          if (value !== this.changeForm.newPassword) {
            callback(new Error("两次输入的密码不一致"));
            return;
          }
          callback();
        },
        trigger: "blur",
      },
    ],
  };
}
